// extracted by mini-css-extract-plugin
export var details = "_gp-0";
export var inspectorPopover = "_gp-1";